<!-- eslint-disable max-len -->
<template>
  <div id="data-list">
    <!-- Title tab -->
    <j-headful :title="$route.meta.title"/>

    <!-- HEADER SECTION -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">VISUAL PROGRAMMING</h4>
      <div
        slot="beforeFilter"
        class="custom-search"
      >
        <b-form inline>
          <button
            type="button"
            class="btn-add-gradient mr-2"
            @click="showCreateList = true"
          >
            <i class="fa fa-plus"/> Create
          </button>
          <b-form
            inline
            class="form-header-list"
            @keypress.13.prevent="filter(filter_data)"
          >
            <j-select
              v-model="select_type"
              :options="options_search"
              :error-required="false"
              placeholder="Filter By"
            />
            <div class="boundary-line" />
            <j-select
              v-if="select_type === 'trigger.type'"
              v-model="select_type_auto"
              :options="options_type"
              :error-required="false"
              placeholder="Select Object"
            />
            <div
              v-if="select_type === 'trigger.type'"
              class="boundary-line"
            />
            <div class="search-input">
              <i class="fa fa-search" />
              <b-form-input
                ref="filterInput"
                v-model="filter_data"
                placeholder="Search"
              />
            </div>
          </b-form>
        </b-form>

        <!-- Popup add visual programming -->
        <div
          v-click-outside="hidePopupCreateList"
          v-if="showCreateList"
          class="popup-add-automation"
        >
          <div
            v-for="list in createList"
            :key="list.section"
            class="list-section"
          >
            <p class="section-text">{{ list.section }}</p>

            <div
              v-for="item in list.lists"
              :key="item.key"
              :class="{ 'inactive': !item.active }"
              class="item-list"
              @click="handleCreateNew(item)"
            >
              <img
                :src="require(`@/assets/${item.icon}`)"
                :alt="item.name"
              >
              <p>{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VISUAL PROGRAMMING -->
    <div class="list-content">
      <j-table-list
        v-click-outside="onClickOutside"
        :columns="columns"
        :sorting="params.sort"
        @sort-change="changeSorting"
      >
        <template slot="table-body">
          <template v-if="!isLoading && dataTable && dataTable.length > 0">
            <tr
              v-for="item in dataTable"
              :key="item.id"
              :class="{'active' : dataSelected && dataSelected.id === item.id }"
              @click="handleSingleClick(item)"
              @dblclick="handleOpenDetail(item)"
              @mouseup.right="handleRightClick(item)"
              @contextmenu.prevent
            >
              <td>
                <div class="icon-id-name">
                  <img
                    v-if="item.trigger.type === 'form'"
                    :src="require('@/assets/automation/data_manager.svg')"
                  >
                  <img
                    v-else-if="item.trigger.type === 'event'"
                    :src="require('@/assets/automation/event.svg')"
                  >
                  <img
                    v-else-if="item.trigger.type === 'function'"
                    :src="require('@/assets/automation/function.svg')"
                  >
                  <img
                    v-else-if="item.trigger.type === 'job' ||
                    item.trigger.type === 'dedicated_job'"
                    :src="require('@/assets/automation/job.svg')"
                  >
                  <img
                    v-else
                    :src="require('@/assets/automation/api.svg')"
                  >
                  <div>
                    <p class="id">{{ item.id }}</p>
                    <p class="name">{{ item.name || '-' }}</p>
                  </div>
                </div>

                <!-- Popup right click -->
                <j-popup-right-click
                  v-if="isShowPopupRightClick && dataSelected && dataSelected.id === item.id"
                  ref="popupRightClick"
                  :use-move="false"
                  @open="handleOpenDetail"
                  @open-new-tab="handleOpenNewTabDetail"
                  @download="handleDownload"
                  @delete="openModalDelete"
                  @detail="handleSingleClick"
                  @rename="toggleModalRename(true)"
                />
              </td>
              <td>
                {{ getType(item) }}
                <span
                  style="font-size: 12px;"
                  v-html="getEvent(item)"
                />
              </td>
              <td>
                <div v-html="getSource(item)"/>
              </td>
              <td>
                <div
                  :class="item.is_active ? 'status-on' : 'status-off'"
                  class="status"
                >
                  <div class="circle-accent" />
                  <span>{{ item.is_active ? 'ON' : 'OFF' }}</span>
                </div>
              </td>
              <td>
                {{ convertDateTime(item.created_at) }}
              </td>
              <td>
                {{ convertDateTime(item.updated_at) }}
              </td>
            </tr>
          </template>

          <!-- If loading first & not have data table -->
          <tr v-if="!isLoading && dataTable === null || (dataTable && dataTable.length === 0)">
            <td
              :colspan="columns.length"
              class="text-center"
            >
              No matching records found
            </td>
          </tr>

          <!-- If Loading or loading more -->
          <template v-if="isLoading || isLoadingMore">
            <tr
              v-for="row in new Array(10)"
              :key="row"
            >
              <td
                v-for="col in new Array(columns.length)"
                :key="col"
              >
                <div class="skeleton-table" />
              </td>
            </tr>
          </template>
        </template>
      </j-table-list>
    </div>

    <!-- Modal delete -->
    <b-modal
      ref="modalDelete"
      class="mod-form modal-form-ui"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <j-popup-delete
        v-if="isShowModalDelete"
        :data-selected="dataSelected"
        @delete="handleDelete"
        @close="closeModalDelete"
      />
    </b-modal>

    <!-- Modal rename -->
    <j-popup-rename
      v-if="isShowModalRename"
      :data-selected ="dataSelectedRename"
      @rename="handleRename"
      @close="toggleModalRename(false)"
    />

    <!-- Modal add new -->
    <b-modal
      ref="modalAddNew"
      :hide-header="true"
      :hide-footer="true"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-add-vp"
    >
      <j-popup-add-new
        v-if="typeAddSelected"
        :type-selected="typeAddSelected"
        :table-group-options="tableGroupOptions"
        :option-event-name="optionEventName"
        @close-modal="closeModalAddNew"
      />
    </b-modal>

    <!-- Modal create by code -->
    <b-modal
      ref="modalAddNewByCode"
      :hide-header="true"
      :hide-footer="true"
      no-close-on-esc
      no-close-on-backdrop
      class="modal-code-vp-wrap"
    >
      <div class="label-create-form-data">CREATE VISUAL PROGRAMMING</div>
      <label> JSON </label>
      <j-monaco-editor
        v-if="showEditor"
        ref="jsonEditor"
        :value="jsonData"
        language="json"
      />
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <button
              class="button-border mr-2"
              @click="closeCodeForm">
              Close
            </button>
            <button
              class="button-blue"
              @click="createCodeData">
              Create
            </button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <j-popup-detail
      v-if="isShowPopupDetail"
      @close-popup="handleClosePopupDetail"
    >
      <j-popup-detail-vp :data-detail="dataSelected" />
    </j-popup-detail>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars */
import ClickOutside from 'vue-click-outside';
import { mapActions, mapState } from 'vuex';
import jApiAutomation from '@/services/jApiAutomation';
import jwtDecode from 'jwt-decode';
import jTableList from '@/components/table/jTableList';
import jPopupRightClick from '@/components/popup/jPopupRightClick';
import jPopupDelete from '@/components/popup/jPopupDelete';
import jPopupRename from '@/components/popup/jPopupRename';
import jPopupDetail from '@/components/popup/jPopupDetail';
import jPopupAddNew from '@/views/visual-programming/popup/jPopupAddNew';
import jPopupDetailVp from '@/views/visual-programming/popup/jPopupDetailVp';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import jMixDataList from '@/mixins/jMixDataList';

export default {
  directives: {
    ClickOutside,
  },

  components: {
    jTableList,
    jPopupRightClick,
    jPopupDelete,
    jPopupRename,
    jPopupAddNew,
    jPopupDetail,
    jPopupDetailVp,
    jMonacoEditor,
  },

  mixins: [
    jMixDataList,
  ],

  data() {
    return {
      showCreateList: false,
      createList: [
        {
          section: 'FILE MANAGEMENT',
          lists: [
            {
              key: 'new_folder',
              name: 'New Folder',
              icon: 'icon/file-folder.svg',
              active: false,
            },
          ],
        },
        {
          section: 'BLANK TRIGGER',
          lists: [
            {
              key: 'form',
              name: 'Data Manager',
              icon: 'automation/data_manager.svg',
              active: true,
            },
            {
              key: 'api_v2',
              name: 'API',
              icon: 'automation/api.svg',
              active: true,
            },
            {
              key: 'webhook_v2',
              name: 'Webhook',
              icon: 'automation/api.svg',
              active: true,
            },
            {
              key: 'function',
              name: 'Function',
              icon: 'automation/function.svg',
              active: true,
            },
            {
              key: 'job',
              name: 'Job',
              icon: 'automation/job.svg',
              active: true,
            },
            {
              key: 'dedicated_job',
              name: 'Dedicated Job',
              icon: 'automation/job.svg',
              active: true,
            },
            {
              key: 'event',
              name: 'Event',
              icon: 'automation/event.svg',
              active: true,
            },
          ],
        },
        {
          section: 'FROM FILE',
          lists: [
            {
              key: 'code',
              name: 'Execute Code',
              icon: 'icon/code.png',
              active: true,
            },
          ],
        },
      ],
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Object',
          value: 'trigger.type',
        },
      ],
      options_type: [
        {
          text: 'Data Manager',
          value: 'form',
        },
        {
          text: 'API',
          value: 'api',
        },
        {
          text: 'Webhook',
          value: 'webhook',
        },
        {
          text: 'Event',
          value: 'event',
        },
        {
          text: 'Function',
          value: 'function',
        },
        {
          text: 'Job',
          value: 'job',
        },
        {
          text: 'Dedicated Job',
          value: 'dedicated_job',
        },
      ],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),

      // Table
      columns: [
        { key: 'name', text: 'Name', sort: true },
        { key: 'type', text: 'Type', sort: false },
        { key: 'source', text: 'Source', sort: false },
        { key: 'is_active', text: 'Status', sort: true },
        { key: 'created_at', text: 'Created At', sort: true },
        { key: 'updated_at', text: 'Updated At', sort: true },
      ],
      params: {
        page: 1,
        limit: 20,
        sort: { updated_at: -1 },
        filter: {},
      },

      typeAddSelected: '',
      jsonData: '',
      filter_data: '',
      select_type: 'name',

      optionEventName: [],
      tableGroupOptions: [],
      select_type_auto: null,
      showEditor: false,
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.params.page = 1;
        this.setParamFilter(val);
        this.getDataList();
      }
    },

    select_type() {
      this.select_type_auto = null;
    },
  },
  created() {
    this.loadOptionsEventName();
    this.getListGroupTable();
  },
  mounted() {
    this.$refs.filterInput.focus();

    this.getDataList();
    const el = document.getElementById('data-list');
    el.onscroll = async () => {
      if (this.isUseInfinityScroll && !this.isFirstLoad) {
        if (Math.floor(el.scrollHeight - el.scrollTop) === el.clientHeight) {
          if (!this.isFirstLoad) {
            this.params.page += 1;
            this.isLoadingMore = true;
            this.isUseInfinityScroll = false;

            const { data } = await this.getDetailAutomation(this.params);
            if (!data.error) {
              if (data.data.length > 0) {
                this.dataTable.push(...data.data);
                setTimeout(() => {
                  this.isUseInfinityScroll = true;
                }, 300);
              } else {
                this.isUseInfinityScroll = false;
              }
              setTimeout(() => {
                this.isLoadingMore = false;
              }, 300);
            }
          }
        }
      }
    };
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'toggleSuccess', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreAutomation', ['getDetailAutomation', 'getListEventNameList', 'createAutomationCode', 'deleteAutomation', 'applyAutomation']),
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId']),

    async getDataList() {
      try {
        this.params.filter.company_id = this.session.user.company_id;
        this.isLoading = true;
        this.isFirstLoad = true;
        this.isUseInfinityScroll = false;
        const { data } = await this.getDetailAutomation(this.params);
        if (!data.error) {
          this.dataTable = data.data;
          this.isLoading = false;
          this.isFirstLoad = false;
          this.isUseInfinityScroll = true;
        }
      } catch (err) {
        this.toggleProblem(err.message);
      }
    },

    getListGroupTable() {
      this.getListDataGroupByCompanyId().then((res) => {
        if (!res.error) {
          this.tableGroupOptions = res.data || [];
        }
      });
    },

    loadOptionsEventName() {
      const options = [];
      this.getListEventNameList().then((data) => {
        data.data.forEach((e) => {
          options.push({ id: e, text: e });
        });
      });
      this.optionEventName = options;
    },

    filter(val) {
      this.params.page = 1;
      this.setParamFilter(val);
      this.getDataList();
    },

    setParamFilter(querySearch) {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      if (this.select_type && querySearch) {
        dataFilter[this.select_type] = this.select_type === 'trigger.type' ? this.select_type_auto : querySearch;
      }
      if (this.select_type === 'trigger.type' && querySearch) {
        let triggerType = '';
        switch (this.select_type_auto) {
          case 'form':
            triggerType = 'trigger.form.form_data_name';
            break;
          case 'api':
            triggerType = 'trigger.api.url';
            break;
          case 'api_v2':
            triggerType = 'trigger.api_v2.url';
            break;
          case 'webhook':
            triggerType = 'trigger.webhook.url';
            break;
          case 'webhook_v2':
            triggerType = 'trigger.webhook_v2.url';
            break;
          case 'event':
            triggerType = 'trigger.event.name';
            break;
          case 'function':
            triggerType = 'trigger.function.name';
            break;
          case 'job':
            triggerType = 'trigger.job.name';
            break;
          case 'dedicated_job':
            triggerType = 'trigger.dedicated_job.name';
            break;
          default:
            triggerType = '';
        }
        dataFilter[triggerType] = querySearch;
      }
      this.params.filter = dataFilter;
    },

    changeSorting(param) {
      this.params.page = 1;
      this.params.sort = param;
      this.getDataList();
    },

    hidePopupCreateList() {
      if (this.showCreateList) this.showCreateList = false;
    },

    handleCreateNew(selected) {
      if (selected.key === 'code') {
        this.$refs.modalAddNewByCode.show();
        setTimeout(() => { this.showEditor = true; }, 500);
      } else if (selected.key !== 'new_folder' && selected.key !== 'code') {
        this.typeAddSelected = selected.key;
        this.$refs.modalAddNew.show();
      }

      this.hidePopupCreateList();
    },

    closeModalAddNew() {
      this.$refs.modalAddNew.hide();
      this.typeAddSelected = '';
    },

    closeCodeForm() {
      this.jsonData = '';
      this.$refs.jsonEditor.changeValue('');
      this.showEditor = false;
      this.$refs.modalAddNewByCode.hide();
    },

    createCodeData() {
      const json = typeof this.$refs.jsonEditor !== 'undefined' ? this.$refs.jsonEditor.getData().trim() : '';
      if (json) {
        const param = JSON.parse(json);
        this.createAutomationCode(param).then((response) => {
          if (!response.error) {
            this.$router.push(`/visual-programming/${response.data.id}`);
          } else {
            this.toggleProblem(response.message);
          }
        });
      }
    },

    handleOpenDetail(data) {
      const id = this.dataSelected ? this.dataSelected.id : data.id;
      this.$router.push(`/visual-programming/${id}`);
    },

    handleOpenNewTabDetail(data) {
      const id = this.dataSelected ? this.dataSelected.id : data.id;
      const url = `${window.location.origin}/#/visual-programming/${id}`;
      window.open(url, '_blank');
    },

    handleDownload() {
      const dataFilter = {
        id: [this.dataSelected.id],
      };
      const param = {
        limit: 10,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((data) => {
        if (!data.data.error) {
          const jsonData = data.data.data[0];

          // Download data from json
          const filename = `${jsonData.name}.json`;
          const contentType = 'application/json;charset=utf-8;';
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            const blob = new Blob([decodeURIComponent(encodeURI(JSON.stringify(jsonData)))], { type: contentType });
            navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            const a = document.createElement('a');
            a.download = filename;
            a.href = `data:${contentType},${encodeURIComponent(JSON.stringify(jsonData))}`;
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        }
      });
    },

    async handleDelete() {
      const param = {
        id: this.dataSelected.id,
      };
      this.showLoading('Please wait...');
      try {
        const response = await jApiAutomation.deleteAutomation(param);
        this.hideLoading('');
        this.toggleSuccess(response.message);
        if (!response.error) {
          this.params.page = 1;
          this.closeModalDelete();
          this.getDataList();
        }
      } catch (err) {
        this.hideLoading('');
        this.toggleProblem(err.response.data.message);
      }
    },

    async handleRename(data) {
      const dataRenamed = this.dataSelectedRename;
      dataRenamed.name = data;
      const index = this.dataTable.findIndex(item => item.id === dataRenamed.id);

      this.applyAutomation({ payload: dataRenamed, useLoading: false }).then(() => {
        this.dataTable[index].name = data;
        this.toggleModalRename(false);
      });
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${dates}/${month}/${years} ${hours}:${minutes}`;
      }
      return null;
    },

    getEvent(data) {
      let event = '';
      if (data.trigger) {
        switch (data.trigger.type) {
          case 'form':
            event = data.trigger.form ? `- ${data.trigger.form.event.replace('_', ' ')}` : '';
            break;
          case 'api':
            event = data.trigger.api ? `- <b>${data.trigger.api.method.toUpperCase()}</b>` : '';
            break;
          case 'api_v2':
            event = data.trigger.api_v2 ? `- <b>${data.trigger.api_v2.method.toUpperCase()}</b>` : '';
            break;
          case 'webhook':
            event = data.trigger.webhook ? `- <b>${data.trigger.webhook.method.toUpperCase()}</b>` : '';
            break;
          case 'webhook_v2':
            event = data.trigger.webhook_v2 ? `- <b>${data.trigger.webhook_v2.method.toUpperCase()}</b>` : '';
            break;
          default :
            event = '';
        }
      }
      return event;
    },

    getSource(data) {
      let source = '';
      if (data.trigger) {
        switch (data.trigger.type) {
          case 'form':
            source = data.trigger.form ? data.trigger.form.form_data_name : '';
            break;
          case 'api':
            source = data.trigger.api ? `<b>{{ base url }}</b>/${data.trigger.api.url}` : '';
            break;
          case 'api_v2':
            source = data.trigger.api_v2 ? `<b>{{ base url }}</b>/${data.trigger.api_v2.url}` : '';
            break;
          case 'webhook':
            source = data.trigger.webhook ? `<b>{{ base url }}</b>/${data.trigger.webhook.url}` : '';
            break;
          case 'webhook_v2':
            source = data.trigger.webhook_v2 ? `<b>{{ base url }}</b>/${data.trigger.webhook_v2.url}` : '';
            break;
          case 'function':
            source = data.trigger.function ? data.trigger.function.name : '';
            break;
          case 'job':
            source = data.trigger.job ? data.trigger.job.name : '';
            break;
          case 'dedicated_job':
            source = data.trigger.dedicated_job ? data.trigger.dedicated_job.name : '';
            break;
          default :
            source = '';
        }
      }
      return source;
    },

    getType(data) {
      let type = '';
      if (data.trigger) {
        switch (data.trigger.type) {
          case 'form':
            type = 'Data Manager';
            break;
          case 'api':
            type = 'API';
            break;
          case 'api_v2':
            type = 'API';
            break;
          case 'webhook':
            type = 'Webhook';
            break;
          case 'webhook_v2':
            type = 'Webhook';
            break;
          case 'event':
            type = 'Event';
            break;
          case 'function':
            type = 'Function';
            break;
          case 'job':
            type = 'Job';
            break;
          case 'dedicated_job':
            type = 'Dedicated Job';
            break;
          default :
            type = '';
        }
      }
      return type;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/jVPList.vue